import { observer } from "mobx-react-lite";
import React, { useCallback } from "react";

import FormField from "../form-field/FormField";
import { dateService } from "../../services/date-service/DateService";
import { DetailType } from "../../pages/settings/project-details/components/DetailType";
import { CustomProjectPropertyValue } from "./CustomProjectPropertyValue";
import { formatNumberBasedOnLanguage } from "../../helpers/MathHelpers";

interface DisplayCustomPropertyProps {
  customProjectPropertyValueState: CustomProjectPropertyValue;
}

export default observer(function DisplayCustomProperty(props: DisplayCustomPropertyProps) {
  const { customProjectPropertyValueState } = props;

  const type = customProjectPropertyValueState.type;
  const label = customProjectPropertyValueState.label;
  const value = customProjectPropertyValueState.value;

  const leadingZero = (num: Number) => `0${num}`.slice(-2);

  const formatTime = useCallback((value: any) => {
    if (!value) return;

    var time: Number[] = value.split(":");
    var formatedDate = time.map(leadingZero).join(":");
    return formatedDate;
  }, []);

  if (type === Number(DetailType.Date))
    return (
      <FormField
        id={`custom-${label}`}
        labelKey={label}
        readOnly
        fieldValue={dateService.formatDate(value) || "-"}
      />
    );

  if (type === Number(DetailType.Number))
    return (
      <FormField
        id={`custom-${label}`}
        labelKey={label}
        readOnly
        fieldValue={formatNumberBasedOnLanguage(value) || "-"}
      />
    );

  if (type === Number(DetailType.Time))
    return (
      <FormField
        id={`custom-${label}`}
        labelKey={label}
        readOnly
        fieldValue={formatTime(value) || "-"}
      />
    );

  return <FormField id={`custom-${label}`} labelKey={label} readOnly fieldValue={value || "-"} />;
});
